export default __webpack_public_path__ + "static/media/M3 (4).77c03eba.jpg";